import React from 'react'

import useFirebase from 'hooks/firebase'

import { 
  BrowserRouter,
  Navigate,
  Route,
  Routes
} from 'react-router-dom'

import ProtectedRoute from 'routes/protected'

import Landing from 'pages/landing'
import SignIn from 'pages/account/signin'
import Admin from 'pages/admin'
import Director from 'pages/director'
import Forgot from 'pages/account/forgot'

const App = (props) => {

  const { auth } = useFirebase()
  const { credentials, user } = auth

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/*' element={<Landing />} />
        <Route path='/login' element={credentials !== undefined && credentials !== null && user !== undefined ? <Navigate replace to={`/${user.role}`} /> : <SignIn />} />
        {/* <Route path='/registro' element={<SignUp />} /> */}
        <Route path='/olvide' element={<Forgot />} />
        <Route path='/director/*' 
          element={
            <ProtectedRoute role='director'>
              <Director />
            </ProtectedRoute>
          } 
        />
         <Route path='/admin/*' 
          element={
            <ProtectedRoute role='admin'>
              <Admin />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App